import React, { useRef } from "react";
import ReactPlayer from "react-player";
import "../styles/ShortsVideoModal.css";

function ShortsVideoModal({
  videoId,
  isOpen,
  onClose,
  title,
  onNext,
  onPrev,
  canGoNext,
  canGoPrev,
}) {
  const touchStartRef = useRef({ x: 0, y: 0 });

  if (!isOpen) return null;

  const isTabletOrMobile =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(max-width: 1024px)").matches;

  const handleTouchStart = (event) => {
    const touch = event.touches[0];
    touchStartRef.current = { x: touch.clientX, y: touch.clientY };
  };

  const handleTouchEnd = (event) => {
    if (!isTabletOrMobile) return;

    const touch = event.changedTouches[0];
    const deltaX = touch.clientX - touchStartRef.current.x;
    const deltaY = touch.clientY - touchStartRef.current.y;
    const absX = Math.abs(deltaX);
    const absY = Math.abs(deltaY);
    const threshold = 45;

    if (absY > absX && absY > threshold) {
      if (deltaY < 0 && canGoNext) onNext();
      if (deltaY > 0 && canGoPrev) onPrev();
      return;
    }

    if (absX > threshold) {
      if (deltaX < 0 && canGoNext) onNext();
      if (deltaX > 0 && canGoPrev) onPrev();
    }
  };

  return (
    <div className="shorts-modal-backdrop" onClick={onClose}>
      <div
        className="shorts-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="shorts-modal-close" onClick={onClose}>
          ×
        </button>
        <div className="shorts-modal-header">
          <h2>{title || "Short"}</h2>
        </div>
        <div
          className="shorts-player-shell"
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          {videoId ? (
            <ReactPlayer
              url={`https://www.youtube.com/shorts/${videoId}`}
              playing={isOpen}
              controls
              width="100%"
              height="100%"
              config={{
                youtube: {
                  playerVars: {
                    rel: 0,
                    modestbranding: 1,
                    playsinline: 1,
                    autoplay: 1,
                  },
                },
              }}
            />
          ) : (
            <div className="shorts-modal-empty">No video ID provided</div>
          )}
          <div className="shorts-nav-column">
            <button
              type="button"
              className="shorts-nav-btn"
              onClick={onPrev}
              disabled={!canGoPrev}
              aria-label="Previous short"
            >
              <span aria-hidden="true">&#9664;</span>
            </button>
            <button
              type="button"
              className="shorts-nav-btn"
              onClick={onNext}
              disabled={!canGoNext}
              aria-label="Next short"
            >
              <span aria-hidden="true">&#9654;</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShortsVideoModal;
